"use client";

import { useEffect, useRef } from "react";
import { useUser } from "@clerk/nextjs";

export default function GTMClerkLoadedEvent() {
  const { isLoaded, user, isSignedIn } = useUser();
  const fired = useRef(false);

  useEffect(() => {
    if (!isLoaded || fired.current) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "clerk_loaded",
      clerkUserId: user?.id ?? null,
      clerkUsername: user?.username ?? null,
      clerkEmail: user?.primaryEmailAddress?.emailAddress ?? null,
      clerkSignedIn: !!isSignedIn,
      clerkFirstName: user?.firstName ?? null,
      clerkLastName: user?.lastName ?? null,
      clerkLastSignInAt: user?.lastSignInAt
        ? new Date(user.lastSignInAt).toISOString()
        : null,
    });

    fired.current = true;
  }, [isLoaded, isSignedIn, user]);

  return null;
}
